import $ from 'jquery';

var goUp = true;
var end = null;
var interval = null;

function handle(delta) {
  var animationInterval = 4; //lower is faster
  var scrollSpeed = 6; //lower is faster

  if (end == null) {
    end = $(window).scrollTop();
  }
  end -= 20 * delta;
  goUp = delta > 0;

  if (interval == null) {
    interval = setInterval(function () {
      var scrollTop = $(window).scrollTop();
      var step = Math.round((end - scrollTop) / scrollSpeed);
      if (scrollTop <= 0 ||
        scrollTop >= $(window).prop("scrollHeight") - $(window).height() ||
        goUp && step > -1 ||
        !goUp && step < 1) {
        clearInterval(interval);
        interval = null;
        end = null;
      }
      $(window).scrollTop(scrollTop + step);
    }, animationInterval);
  }
}

function wheel(event) {
  var delta = 0;
  if (event.wheelDelta) delta = event.wheelDelta / 120;
  else if (event.detail) delta = -event.detail / 3;

  handle(delta);
  if (event.preventDefault) event.preventDefault();
  event.returnValue = false;
}

function startScroll() {
	return;
  if (window.addEventListener) window.addEventListener('DOMMouseScroll', wheel, false);
  window.onmousewheel = document.onmousewheel = wheel;
}

function stopScroll() {
	return;
  window.removeEventListener('DOMMouseScroll', wheel, false);
}

export {
  startScroll,
  stopScroll
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/scroll-ease.js